function setImageHeight(target){
    const menuMobileLinkContainer = window.document.getElementById('LinksContainerMobile');
    const header = window.document.getElementsByTagName('header')[0];
    const headerHeight = header ? header.offsetHeight : 0;
    
    if(!menuMobileLinkContainer) return;

    const linkListContainer = window.document.getElementById('LinksListMobile');
    
    if(!target || !linkListContainer) return;

    const heigth = window.innerHeight - linkListContainer.offsetTop - linkListContainer.offsetHeight - headerHeight + "px";

    target.children[0].style.height = heigth;

    target.querySelector('img') ? target.querySelector('img').style.height = heigth : null;
}

window.addEventListener('load',function(){
    const menuMobileLinkContainer = window.document.getElementById('LinksContainerMobile');
    const target = window.document.getElementById('ImageBlockTarget');


    if (!menuMobileLinkContainer) return;
    
    const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            if (mutation.type !== "attributes") return;
            if (mutation.target.getAttribute('data-level') === "1") return;
            
            const linkListContainer = window.document.getElementById('LinksListMobile');
            const header = window.document.getElementsByTagName('header')[0];
            const headerHeight = header ? header.offsetHeight : 0;
            
            if(!linkListContainer) return;
            const height = window.innerHeight - mutation.target.offsetHeight - headerHeight + "px";
            target.children[1].style.height = height;
            target.children[1].querySelectorAll('img').forEach(img=>img.style.height = height);
            target.children[1].style.marginTop = mutation.target.offsetHeight - linkListContainer.offsetHeight + "px";
            
        });
    });

    observer.observe(menuMobileLinkContainer, {
        attributes: true 
    });

    const hamburgerMenu = window.document.querySelector('button[aria-controls="MobileNav"]');
    if(hamburgerMenu) {
        hamburgerMenu?.addEventListener('click',function(){
            setImageHeight(target);
        });
    }
});

window.addEventListener('load',function(){
    const links = window.document.querySelectorAll('#LinksContainerMobile .slide-nav__item');

    if (links.length < 1) return;

    links.forEach(link => {
        link.addEventListener('click',function(e){
            links.forEach((link,index) => {
                if(link === this) {
                    const parent = link.parentElement;
                    const childIndex = Array.prototype.indexOf.call(parent?.children,link) + "";
                    const level = parent.getAttribute('data-level');
                    switch(level){
                        case "1":{
                            const imagesBlock = window.document.querySelectorAll('div[data-featured-image-index]');
                            imagesBlock.forEach(block =>{
                                if (block.getAttribute('data-featured-image-index') === childIndex)
                                    block.classList.add('is-visible');
                                else
                                    block.classList.remove('is-visible');
                            })
                            break;
                        }
                        case "2":{break;}
                        case "3":{break;}
                    }
                }
                else link.classList.remove('selected-menu');
            })
        })
    })
})